import { ProfileSettingType } from '@diritto/common/account/constants/profile-setting.constant';
import { SsoType } from '@diritto/common/account/constants/sso.constant';
import { WebViewEvent, WebViewEventParams, WebViewEventType } from '@diritto/common/app/webview-event.constant';
import { WebViewTrackingEventParams } from '@diritto/common/app/webview-tracking-event.constant';
import { TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';

export class DirittoAppBridge {
  static sendToApp(type: WebViewEventType, message?: WebViewEventParams[typeof type]) {
    if (typeof window !== 'undefined') {
      window.ReactNativeWebView?.postMessage?.(JSON.stringify({ type, message } as WebViewEvent<WebViewEventType>));
    }
  }

  static openSign() {
    this.sendToApp(WebViewEventType.OpenSign);
  }

  static requestSign(ssoType: SsoType, isForLink: boolean) {
    this.sendToApp(WebViewEventType.RequestSign, { ssoType, isForLink });
  }

  static completeSign(token?: { accessToken: string; refreshToken: string }) {
    this.sendToApp(WebViewEventType.CompleteSign, { token });
  }

  static openSignView(url: string) {
    this.sendToApp(WebViewEventType.OpenSignWebView, { url });
  }

  static closeSignView() {
    this.sendToApp(WebViewEventType.CloseSignWebView);
  }

  static openExternalView(url: string, title?: string) {
    this.sendToApp(WebViewEventType.OpenExternalWebView, { url, title });
  }

  static closeExternalView() {
    this.sendToApp(WebViewEventType.CloseExternalWebView);
  }

  static changePushOn(isPushOn: boolean) {
    this.sendToApp(WebViewEventType.SetPushOn, { isPushOn });
  }

  static getPushOn() {
    this.sendToApp(WebViewEventType.GetPushOn);
  }

  static requestCameraPermission() {
    this.sendToApp(WebViewEventType.RequestCameraPermission);
  }

  static preventScreenshot(enable: boolean) {
    this.sendToApp(WebViewEventType.PreventScreenshot, { enable });
  }

  static share(params: { files?: File[]; text?: string; title: string; url: string }) {
    this.sendToApp(WebViewEventType.Share, params);
  }

  static fileDownload(params: { url: string }) {
    this.sendToApp(WebViewEventType.FileDownload, params);
  }

  static copyText(text: string) {
    this.sendToApp(WebViewEventType.CopyText, { text });
  }

  static requestInAppReview() {
    this.sendToApp(WebViewEventType.RequestInAppReview);
  }

  static requestProfileSetting(type: ProfileSettingType) {
    this.sendToApp(WebViewEventType.RequestProfileSetting, { type });
  }

  static trackEvent<E extends TrackingEventType>(event: E, params?: WebViewTrackingEventParams[E]) {
    this.sendToApp(WebViewEventType.TrackEvent, {
      event,
      params,
    });
  }

  static trackSetPeople(params: WebViewEventParams[WebViewEventType.TrackSetPeople]) {
    this.sendToApp(WebViewEventType.TrackSetPeople, params);
  }

  static showAppHeader(params: WebViewEventParams[WebViewEventType.ShowAppHeader]) {
    this.sendToApp(WebViewEventType.ShowAppHeader, params);
  }

  static changeStatusBar(params: WebViewEventParams[WebViewEventType.ChangeStatusBar]) {
    this.sendToApp(WebViewEventType.ChangeStatusBar, params);
  }

  static historyBack() {
    this.sendToApp(WebViewEventType.HistoryBack);
  }

  static navigateBack() {
    this.sendToApp(WebViewEventType.NavigateBack);
  }

  static resetToHome() {
    this.sendToApp(WebViewEventType.ResetToHome);
  }

  static showToast(text: string) {
    this.sendToApp(WebViewEventType.ShowToast, { text });
  }

  static setVolumeIntercept(enabled: boolean) {
    this.sendToApp(WebViewEventType.SetVolumeIntercept, { enabled });
  }
}
